import { Info } from "@mui/icons-material";
import { Button, Stack, Typography } from "@mui/material";
import { PropsWithChildren } from "react";
import i18n from "../../services/localization-service/i18n";

export type SectionActionPayloadType = Section;

export type Section = {
    expanded: boolean;
};

export enum SectionActionEnum {
    Edit = 1,
    Duplicate = 2,
    Delete = 3,
    Rename = 4,
    ToggleExpansion = 5
}

export type StepMenuLandingCardListProps = {
    expandAllButtonLabel?: string | null;
    hideExpandAllButton?: boolean;
    onExpandAll?: () => void;

    collapseAllButtonLabel?: string | null;
    hideCollapseAllButton?: boolean;
    onCollapseAll?: () => void;

    addSectionButtonLabel?: string | null;
    hideAddSectionButton?: boolean;
    disableAddSectionButton?: boolean;
    onAddSection?: () => void;

    title?: string | null;
    info?: string | null;
    scrollable?: boolean;
};

export default function StepMenuLandingCardList({
    children,
    expandAllButtonLabel = i18n.t("stepMenu.expandAll"),
    hideExpandAllButton = false,
    onExpandAll,
    collapseAllButtonLabel = i18n.t("stepMenu.collapseAll"),
    hideCollapseAllButton = false,
    onCollapseAll,
    addSectionButtonLabel = i18n.t("stepMenu.addSection"),
    hideAddSectionButton = false,
    disableAddSectionButton = false,
    onAddSection,
    info,
    title,
    scrollable
}: PropsWithChildren<StepMenuLandingCardListProps>) {

    return (
        <Stack
            direction="column"
            sx={{
                flexGrow: 1,
                overflow: "hidden"
            }}>
            {title && info &&
                <Typography
                    variant="subtitle1"
                    sx={{
                        padding: 1,
                        paddingBottom: 0,
                        fontWeight: "fontWeightBold"
                    }}
                >
                    {title}
                </Typography>
            }
            <Stack
                direction="row"
                spacing={1}
                sx={{
                    flexGrow: 0,
                    flexShrink: 0,
                    overflow: "hidden",
                    alignItems: "center",

                    // paddingTop: 0,
                    // paddingBottom: 0
                    padding: 1
                }}>
                {title && !info &&
                    <Typography
                        variant="subtitle1"
                        sx={{
                            padding: 1,
                            paddingLeft: 0,
                            fontWeight: "fontWeightBold",
                            flexGrow: 1
                        }}
                    >
                        {title}
                    </Typography>
                }

                {info &&
                    <Typography
                        variant="body2"
                        sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            flexDirection: "row",
                            flexGrow: 1
                        }}
                    >
                        <Info fontSize="small" sx={{ marginRight: 1 }} />{info}
                    </Typography>
                }

                {!hideExpandAllButton &&
                    <Button onClick={() => onExpandAll && onExpandAll()} sx={{ flexShrink: 0, marginLeft: "auto" }}>
                        {expandAllButtonLabel}
                    </Button>
                }
                {!hideCollapseAllButton &&
                    <Button onClick={() => onCollapseAll && onCollapseAll()} sx={{ flexShrink: 0, marginLeft: "auto" }}>
                        {collapseAllButtonLabel}
                    </Button>
                }
                {!hideAddSectionButton &&
                    <Button onClick={() => onAddSection && onAddSection()} disabled={disableAddSectionButton} sx={{ flexShrink: 0, marginLeft: "auto" }}>
                        {addSectionButtonLabel}
                    </Button>
                }
            </Stack>
            <Stack 
                spacing={1}
                sx={{
                    overflowY: scrollable 
                        ? "auto"
                        : "hidden",
                    overflowX: "hidden",
                    //overflow: 'hidden',
                    paddingBottom: 1,
                }}>
                {children}
            </Stack>
        </Stack>
    );
}
